import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MapIcon from '@mui/icons-material/Map';

interface MapDataButtonProps {
  selectedRows?: string[];
  campaignId?: string;
  setShowMap: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedNetworkType: React.Dispatch<React.SetStateAction<string>>;
  styleOverrides?: React.CSSProperties;
  disabled?: boolean;
}

const MapDataButton: React.FC<MapDataButtonProps> = ({
  selectedRows,
  campaignId,
  setShowMap,
  setSelectedNetworkType,
  styleOverrides,
  disabled,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMapData = (networkType: string) => {
    setSelectedNetworkType(networkType);
    setShowMap(true);
    handleClose();
  };

  // Check if we have either selectedRows or campaignId
  const hasData = (selectedRows && selectedRows.length > 0) || campaignId;
  const isDisabled = disabled !== undefined ? disabled : !hasData;

  return (
    <div style={styleOverrides}>
      <Button
        variant="contained"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        startIcon={<MapIcon />}
        disabled={isDisabled}
      >
        Map Data
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            document.body.removeAttribute('style');
            handleMapData('cellular');
          }}
        >
          Map Cellular Data
        </MenuItem>
        <MenuItem
          onClick={() => {
            document.body.removeAttribute('style');
            handleMapData('wifi');
          }}
        >
          Map WiFi Data
        </MenuItem>
      </Menu>
    </div>
  );
};

export default MapDataButton;